import React from "react";
import ReactApexCharts from "react-apexcharts";
import { Empty } from "antd";
import { FormatUSD } from "../../../utils/helpers/string";

function RoundedBarChart({ data, color1, color2, dataSymbol }) {
  const defaultData = { data: [], time: [] };
  const chartData = data || defaultData;

  const options = {
    series: [
      {
        name: "Performance",
        data: chartData?.data,
      },
    ],
    chart: {
      type: "bar",
      height: 350,
      toolbar: {
        show: false,
      },
    },
    grid: {
      show: false,
      // strokeDashArray: 4, // Optional: Add dashed grid lines
      strokeOpacity: 0, // Set the opacity of the grid lines here
    },
    plotOptions: {
      bar: {
        colors: {
          ranges: [
            {
              from: -Infinity,
              to: 0,
              color: color2,
            },
            {
              from: 0,
              to: Infinity,
              color: color1,
            },
          ],
        },
        columnWidth: "20%",
      },
    },
    dataLabels: {
      enabled: false,
    },
    yaxis: {
      title: {
        text:
          dataSymbol.charAt(0).toUpperCase() +
          dataSymbol.slice(1).toLowerCase(),
      },

      labels: {
        formatter: function (y) {
          const value = Math.abs(y) < 1 ? y.toFixed(2) : y.toFixed(0);
          return dataSymbol === "amount"
            ? FormatUSD(value) : dataSymbol === "percentage" ? value + "%"
              : value;
        },
        style: {
          fontSize: "12px",
        },
      },
      tickAmount: 5,
      forceNiceScale: true,
      min: function (min) {
        return Math.floor(min);
      },
      max: function (max) {
        return Math.ceil(max);
      },
      decimalsInFloat: 0,
      floating: false,
      tickPlacement: "on",
      axisTicks: {
        show: true,
        color: "#78909C",
        width: 6,
        offsetX: 0,
        offsetY: 0,
      },
    },
    xaxis: {
      type: "category",
      categories: chartData?.time,
      labels: {
        rotate: -90,
      },
      title: {
        text: "Time",
      },
    },
    annotations: {
      yaxis: [
        {
          y: 0,
          borderColor: "#fff",
          borderWidth: 0.6,
          label: {
            borderColor: "#000",
            style: {
              color: "#fff",
              background: "#000",
            },
            // text: "Center Line",
          },
        },
      ],
    },
  };

  return (
    <div className="chart-wrapper">
      {!chartData?.data?.length ? (
        <div
          className="no-data-message"
          style={{
            height: "100%",
            minHeight: "250px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Empty
            description={
              <span style={{ color: "#fff" }}>No Data Available</span>
            }
          />
        </div>
      ) : (
        <ReactApexCharts
          options={options}
          series={options.series}
          type="bar"
          height="100%"
        />
      )}
    </div>
  );
}

export default RoundedBarChart;
